"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Sorts an array.
 * @param array Base array
 * @param compareFn The name of the function used to determine the order of the elements. If omitted, the elements are sorted in ascending, ASCII character order.
 */
function sort(array, compareFn) {
    return array.slice().sort(compareFn);
}
exports.sort = sort;
//# sourceMappingURL=sort.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/@immutable-array/sort/lib/sort.js
// module id = 970
// module chunks = 0